import { NodeViewSettingsPanel } from '@/components/common/node-view-settings-panel';
import { CommonNodeViewWrapper } from '@/components/common/node-view-wrapper';
import type { ReactNodeViewProps } from '@tiptap/react';
import { NodeViewContent } from '@tiptap/react';

export function ZyBlockNodeView(props: ReactNodeViewProps) {
    const { node, updateAttributes, selected, decorations } = props;
    const nobox = node.attrs.nobox ?? false;

    const handleNoBoxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        updateAttributes({
            nobox: e.target.checked,
        });
    };

    const mainContent = (
        <div className={`border-l-4 border-gray-300 p-4 ${nobox ? 'bg-transparent' : 'bg-gray-100'}`}>
            <NodeViewContent />
        </div>
    );

    return (
        <CommonNodeViewWrapper
            decorations={decorations}
            label="zyBlock"
            selected={selected}
            settingsPanel={
                <NodeViewSettingsPanel
                    fields={[
                        {
                            type: 'checkbox',
                            label: 'No background',
                            checked: nobox,
                            onChange: handleNoBoxChange,
                        },
                    ]}
                />
            }
            contentClassName="px-4 pb-4"
            fullscreenContent={mainContent}
            fullscreenMode="inline"
            contentHeightClassName=""
            containerClassName="bg-white dark:bg-black"
        >
            {mainContent}
        </CommonNodeViewWrapper>
    );
}
